import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { CurrencyWithPlaceholderFallback } from './CurrencyWithPlaceholderFallback';

export const WithdrawalAmountRow = ({
    drawdownAmount
}: {
    drawdownAmount: number;
}) => (
    <div className="flex items-center justify-between">
        <Text>
            <FormattedMessage
                id="_.loan_summary.withdrawal_amount"
                defaultMessage="Withdrawal amount:"
            />
        </Text>
        <Text className="font-bold">
            <CurrencyWithPlaceholderFallback value={drawdownAmount} />
        </Text>
    </div>
);
